import { Box, Modal } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { RootState } from "../app/store";
import { deleteUserAccount } from "../features/User/UserSlice";
import CustomButton from "./CustomButton";
import "../styles/components/delete-account.scss";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const DeleteUserAccount: React.FC = () => {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();
  const { id } = useSelector((state: RootState) => state.user);

  const deleteAccountDispatcher = async () => {
    const output = (await dispatch(deleteUserAccount(id))) as any;
    if (output?.type === "habit/deleteUserAccount/fulfilled") {
      handleClose();
      history.push("/home");
    }
  };

  return (
    <div className="delete-account">
      <CustomButton
        onClick={() => handleOpen()}
        displayText="Delete My Account"
        className="delete-user-button"
        style={{
          color: "black",
          background: "rgba(255, 119, 119)",
          border: "2px solid black",
          width: "12.5rem",
          boxShadow: "5px 5px 0",
        }}
      />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="delete-account-modal"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
          className="box"
        >
          <h3 style={{ textAlign: "center" }}>
            Are you sure you want to delete your account? This action is
            irreversible and all your habits and data would be lost.
          </h3>

          <CustomButton
            displayText="Yes, delete my account."
            style={{
              color: "black",
              background: "rgba(255, 119, 119)",
              border: "2px solid black",
              width: "12.5rem",
              boxShadow: "5px 5px 0",
            }}
            onClick={() => deleteAccountDispatcher()}
          />
        </Box>
      </Modal>
    </div>
  );
};

export default DeleteUserAccount;
